module.exports = __webpack_public_path__ + "Tinebase/js/ace-mode-php_laravel_blade-FAT.js";